import React, { useContext } from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  BRAND_COLOR,
  PORTAL_PREFIX,
  PAGE_PORTAL_FINANCE_RECEIPTS_LIST,
  KivuI18nContext,
  localizedPath,
  useKivunovaTranslation
} from "@kivunova/kivufrontendcommon";

const NoReceiptDetailFound: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useKivunovaTranslation();
  const { language, defaultLang } = useContext(KivuI18nContext) || {};

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="400px"
      gap={3}
    >
      <Typography variant="h6" color="text.primary" fontWeight="bold">
        {t("receipt-not-found", "Receipt not found")}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {t(
          "receipt-not-found-description",
          "The receipt you're looking for doesn't exist or has been removed."
        )}
      </Typography>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() =>
          navigate(
            localizedPath(
              `/${PORTAL_PREFIX}/${PAGE_PORTAL_FINANCE_RECEIPTS_LIST}`,
              language,
              defaultLang
            )
          )
        }
        sx={{ color: BRAND_COLOR, textTransform: "none" }}
      >
        {t("back-to-receipts", "Back to Receipts")}
      </Button>
    </Box>
  );
};

export default NoReceiptDetailFound;
